// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1ds96","image":"Header_image__1YLrK","name":"Header_name__1Rbm6","info":"Header_info__3_Ply","infoRow":"Header_infoRow__AbI7L"};